import { render } from "./RestaurantOrdersView.vue?vue&type=template&id=3105f306&scoped=true"
import script from "./RestaurantOrdersView.vue?vue&type=script&lang=js"
export * from "./RestaurantOrdersView.vue?vue&type=script&lang=js"

import "./RestaurantOrdersView.vue?vue&type=style&index=0&id=3105f306&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3105f306"]])

export default __exports__